<template>
  <div>
    <v-dialog v-model="userModel" width="900" persistent>
      <v-card-actions class="headline">
        <div class="headline">
          <span class="text-capitalize">{{ userDetails.name || "" }} </span>
        </div>
        <v-spacer></v-spacer>
      </v-card-actions>
      <v-card>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col col="4">
                <v-card>
                  <view-image
                    :image="userDetails.profile_image"
                    default_image="user"
                  ></view-image>
                </v-card>
              </v-col>
              <v-col col="8">
                <v-card tile elevation="0">
                  <v-list class="transparent" dense>
                    <v-list-item>
                      <v-list-item-icon>
                        <v-icon>mdi-account</v-icon>
                      </v-list-item-icon>
                      <v-list-item-subtitle class="text-left"
                        >Name</v-list-item-subtitle
                      >
                      <v-list-item-title class="font-weight-black text-left">
                        <span class="text-capitalize"
                          >{{ userDetails.name || "" }}
                        </span>
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-icon>
                        <v-icon>mdi-phone</v-icon>
                      </v-list-item-icon>
                      <v-list-item-subtitle class="text-left"
                        >Mobile</v-list-item-subtitle
                      >
                      <v-list-item-title class="font-weight-black text-left">
                        {{ userDetails.mobile || "NA" }}
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-icon>
                        <v-icon>mdi-account-circle</v-icon>
                      </v-list-item-icon>
                      <v-list-item-subtitle class="text-left"
                        >Username</v-list-item-subtitle
                      >
                      <v-list-item-title class="font-weight-black text-left">
                        <span class="text-capitalize"
                          >{{ userDetails.username || "" }}
                        </span>
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-icon>
                        <v-icon>mdi-email</v-icon>
                      </v-list-item-icon>
                      <v-list-item-subtitle class="text-left"
                        >Email</v-list-item-subtitle
                      >
                      <v-list-item-title class="font-weight-black text-left">
                        {{ userDetails.email || "NA" }}
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-icon>
                        <v-icon>mdi-professional-hexagon</v-icon>
                      </v-list-item-icon>
                      <v-list-item-subtitle class="text-left"
                        >Profession</v-list-item-subtitle
                      >
                      <v-list-item-title class="font-weight-black text-left">
                        <span class="text-capitalize"
                          >{{ userDetails.profession || "" }}
                        </span>
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-icon>
                        <v-icon>mdi-domain</v-icon>
                      </v-list-item-icon>
                      <v-list-item-subtitle class="text-left"
                        >Company name</v-list-item-subtitle
                      >
                      <v-list-item-title class="font-weight-black text-left">
                        <span class="text-capitalize"
                          >{{ userDetails.company_name || "" }}
                        </span>
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-icon>
                        <v-icon>mdi-counter</v-icon>
                        <span class="users_tab_name"></span>
                      </v-list-item-icon>
                      <v-list-item-subtitle class="text-left"
                        >Date of Birth (Age)</v-list-item-subtitle
                      >
                      <v-list-item-title
                        v-if="userDetails.dob"
                        class="font-weight-black text-left"
                      >
                        {{ userDetails.dob | dateformat }}
                        <span v-if="userDetails.age"
                          >({{ userDetails.age }})</span
                        >
                      </v-list-item-title>
                      <v-list-item-title
                        v-else
                        class="font-weight-black text-left"
                      >
                        NA
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-icon>
                        <v-icon>mdi-gender-male-female</v-icon>
                      </v-list-item-icon>
                      <v-list-item-subtitle class="text-left"
                        >Gender</v-list-item-subtitle
                      >
                      <v-list-item-title class="font-weight-black text-left">
                        {{ userDetails.gender || "NA" }}
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-icon>
                        <v-icon>mdi-flag</v-icon>
                      </v-list-item-icon>
                      <v-list-item-subtitle class="text-left"
                        >Nationality</v-list-item-subtitle
                      >
                      <v-list-item-title class="font-weight-black text-left">
                        {{
                          userDetails.country_name
                            ? userDetails.country_name
                            : "NA"
                        }}
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-icon>
                        <v-icon>mdi-tablet-cellphone</v-icon>
                      </v-list-item-icon>
                      <v-list-item-subtitle class="text-left"
                        >Device Type</v-list-item-subtitle
                      >
                      <v-list-item-title class="font-weight-black text-left">
                        <span class="text-capitalize"
                          >{{ userDetails.device_type || "" }}
                        </span>
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-icon>
                        <v-icon>mdi-map-clock</v-icon>
                      </v-list-item-icon>
                      <v-list-item-subtitle class="text-left"
                        >Time zone</v-list-item-subtitle
                      >
                      <v-list-item-title class="font-weight-black text-left">
                        <span class="text-capitalize"
                          >{{
                            userDetails.timezone ? userDetails.timezone : "NA"
                          }}
                        </span>
                      </v-list-item-title>
                    </v-list-item>

                    <v-list-item>
                      <v-list-item-icon>
                        <v-icon>mdi-information</v-icon>
                      </v-list-item-icon>
                      <v-list-item-subtitle class="text-left"
                        >About</v-list-item-subtitle
                      >
                      <v-list-item-title class="font-weight-black text-left">
                        <span class="text-capitalize"
                          >{{ userDetails.about || "" }}
                        </span>
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-icon>
                        <v-icon>mdi-cellphone-check</v-icon>
                      </v-list-item-icon>
                      <v-list-item-subtitle class="text-left"
                        >Phone Verified</v-list-item-subtitle
                      >
                      <v-list-item-title class="font-weight-black text-left">
                        <span class="text-capitalize"
                          >{{
                            userDetails.is_phone_verified &&
                            userDetails.is_phone_verified == 1
                              ? "Yes"
                              : "No"
                          }}
                        </span>
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-icon>
                        <v-icon>mdi-bell</v-icon>
                      </v-list-item-icon>
                      <v-list-item-subtitle class="text-left"
                        >Notification Status</v-list-item-subtitle
                      >
                      <v-list-item-title class="font-weight-black text-left">
                        <span class="text-capitalize"
                          >{{
                            userDetails.notification_enabled &&
                            userDetails.notification_enabled == 1
                              ? "Enabled"
                              : "Disabled"
                          }}
                        </span>
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-icon>
                        <v-icon>mdi-vpn</v-icon>
                      </v-list-item-icon>
                      <v-list-item-subtitle class="text-left"
                        >Is Private</v-list-item-subtitle
                      >
                      <v-list-item-title class="font-weight-black text-left">
                        <span class="text-capitalize"
                          >{{
                            userDetails.is_private &&
                            userDetails.is_private == 1
                              ? "Yes"
                              : "No"
                          }}
                        </span>
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-icon>
                        <v-icon>mdi-account-check</v-icon>
                      </v-list-item-icon>
                      <v-list-item-subtitle class="text-left"
                        >Is Profile Completed</v-list-item-subtitle
                      >
                      <v-list-item-title class="font-weight-black text-left">
                        <span class="text-capitalize"
                          >{{
                            userDetails.is_profile_completed &&
                            userDetails.is_profile_completed == 1
                              ? "Yes"
                              : "No"
                          }}
                        </span>
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-icon>
                        <v-icon>mdi-email-check</v-icon>
                      </v-list-item-icon>
                      <v-list-item-subtitle class="text-left"
                        >Is Email Verified</v-list-item-subtitle
                      >
                      <v-list-item-title class="font-weight-black text-left">
                        <span class="text-capitalize"
                          >{{
                            userDetails.is_email_verified &&
                            userDetails.is_email_verified == 1
                              ? userDetails.email_verified_at &&
                                userDetails.email_verified_at != "null" &&
                                userDetails.email_verified_at != ""
                                ? "Yes. At" + userDetails.email_verified_at
                                : "Yes"
                              : "No"
                          }}
                        </span>
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-icon>
                        <v-icon>mdi-login</v-icon>
                      </v-list-item-icon>
                      <v-list-item-subtitle class="text-left"
                        >Is Logged in</v-list-item-subtitle
                      >
                      <v-list-item-title class="font-weight-black text-left">
                        <span class="text-capitalize"
                          >{{
                            userDetails.is_online && userDetails.is_online == 1
                              ? "Yes"
                              : userDetails.last_seen &&
                                userDetails.last_seen != "null" &&
                                userDetails.last_seen != ""
                              ? "No. last seen at" + userDetails.last_seen
                              : "No"
                          }}
                        </span>
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-icon>
                        <v-icon>mdi-code-string</v-icon>
                      </v-list-item-icon>
                      <v-list-item-subtitle class="text-left"
                        >Refferer Code</v-list-item-subtitle
                      >
                      <v-list-item-title class="font-weight-black text-left">
                        <span class="text-capitalize"
                          >{{
                            userDetails.referrer_code
                              ? userDetails.referrer_code
                              : "NA"
                          }}
                        </span>
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-icon>
                        <v-icon>mdi-list-status</v-icon>
                      </v-list-item-icon>
                      <v-list-item-subtitle class="text-left"
                        >Status</v-list-item-subtitle
                      >
                      <v-list-item-title class="font-weight-black text-left">
                        <span class="text-capitalize"
                          >{{ userDetails.status ? userDetails.status : "NA" }}
                        </span>
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-icon>
                        <v-icon>mdi-calendar-month-outline</v-icon>
                      </v-list-item-icon>
                      <v-list-item-subtitle class="text-left"
                        >Created at</v-list-item-subtitle
                      >
                      <v-list-item-title class="font-weight-black text-left">
                        <span class="text-capitalize"
                          >{{
                            userDetails.created_date
                              ? userDetails.created_date
                              : "NA"
                          }}
                        </span>
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color=" darken-1"
            class="ma-2 white--text green-color"
            text
            @click="
              () => {
                $emit('close');
                userModel = false;
              }
            "
            >Close</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    userID: { type: Number, default: null },
    type: { type: String, default: "details" },
    isPermissionCheck: { type: Boolean, default: true },
  },
  data() {
    return {
      userModel: false,
      userDetails: {},
      image: null,
      menu: false,
      user: {},
      valid: false,
      creditList: [],
      page: 1,
      totalPages: 1,
      orderId: null,
    };
  },
  watch: {
    userID(val) {
      if (val != null) {
        this.getUserDetails();
      }
    },
    menu(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
    },
  },
  mounted() {},
  computed: {},
  methods: {
    getUserDetails() {
      this.$http
        .get("users/user-details/" + this.userID)
        .then((response) => {
          if (response.status == 200 && response.data.status) {
            this.userDetails = response.data.data;
            this.userModel = true;
          }
        })
        .catch((error) => {
          this.errorChecker(error);
        });
    },

    closeAll() {
      this.userModel = false;
      this.valid = false;
      this.$emit("close");
    },
    closeEdit() {
      if (this.type == "details") {
        this.userModel = true;
        this.getUserDetails();
      } else {
        this.image = null;
        this.$emit("close");
        this.$refs.form.resetValidation();
      }
    },
  },
};
</script>

<style scoped>
.personal-trainer_ic {
  /* background-image: url("../../../assets/images/nav_icon/personal-trainer-grey.png"); */
  padding: 10px;
  background-size: contain;
}

.credit_table table thead tr th {
  background: #066a8c !important;
  color: #fff !important;
}
</style>
